<template>
    <UpdatePart></UpdatePart>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const UpdatePart = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/PartMaintenance/UpdatePart.vue"
    )
);

export default {
    name: "Project_HelpUpdatePart", //The name you are in should not equal the name of the component you are importing.
    components: { UpdatePart, AuthLayout },
};
</script>
